module.exports = __webpack_public_path__ + "img/number_8.158f82ee.png";